// export const BASE_URL  = 'http://4.240.108.67/';
export const BASE_URL  = 'https://devapi.truckexpress.in/';

// export const BASE_URL  = 'http://192.168.14.90:8000/';